import { Component, OnInit } from '@angular/core';
import { IPackageBuider } from '../Domains/packageBuilder';
import { SelectItem, ConfirmationService, MessageService } from 'primeng/api';
import { IUser } from '../Domains/IUser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Configuration } from 'config/config';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ICompanyContactPackageBuider } from '../Domains/companyContactPackageBuilder';
import { AuthService } from 'common/services/auth.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from '../Domains/branch';
import { buildPackageBuilderCreatePayload } from 'common/services/package-builder-payload.util';
import {
  PACKAGE_DAYS_OF_WEEK,
  TimeBasedExceptionFormRow,
  applyTimeBasedFieldsToPackage,
  createEmptyExceptionRow,
  describeAccessWindowSelection,
  describeAllAccessWindows,
  getExceptionRowTitle as resolveExceptionRowTitle,
  hasSelectedZones,
  validateTimeBasedAccess,
} from 'common/services/package-time-based.util';
@Component({
  selector: 'app-addpackage-builder',
  templateUrl: './addpackage-builder.component.html',
  styleUrls: ['./addpackage-builder.component.css']
})
export class AddpackageBuilderComponent implements OnInit {
  activeIndex: number = 0;
  items: any[] = [];
  package: IPackageBuider;
  selectedLogo: any;
  packagesLogo: SelectItem[];
  user: IUser;
  isMonthWisePackage: boolean = false;
  isPersonWisePackage: boolean = false;
  branch:IBranch;
  //isCompanyWisePackage: boolean = false;
  packageFeeTypes: any[] = [];
  packageFeePersonWiseTypes: any[] = [];
  packageDurationTypes: any[] = [];
  packageRegFeePersonWiseTypes: any[] = [];
  loading:boolean;
  packageFeeType: any;
  packageDurationType: any;
  packages: IPackageBuider[] = [];
  sourcePackages: IPackageBuider[];
  zones: any[] = [];
  currentUser = '';
  branchId = '';
  zoneSaveTouched: boolean = false;
  groupFeePayByOnePerson: boolean = false;
  sameHistory: boolean = false;
  hasReadFeeCollectionDesc: boolean = false;
  isTimeBased: boolean = false;
  exceptionRows: TimeBasedExceptionFormRow[] = [];
  daysOfWeekOptions = PACKAGE_DAYS_OF_WEEK;
  confirmationDialogVisible = false;
  confirmationDialogMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;
  constructor(
    private LanguageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
    public config: Configuration,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager) { }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddpackageBuilderComponent", label);
  }
  ngOnInit() {
    this.InitObjects();
    this.steps();
    this.user = AuthService.getLoggedInUser();
    this.branch=AuthService.getLoggedInCurrentBranch();
    this.getZonesByBranchID();
    this.packagesLogo = [
      { label: 'Muscle', value: 'muscle' },
      { label: 'Gym', value: 'gym' },
      { label: 'Gym Builder', value: 'gymbuilder' },
      { label: 'Gymnasium', value: 'gymnasium' },
      { label: 'Dumbbell', value: 'dumbbell' },
      { label: 'Effort', value: 'effort' },
      { label: 'Monthly', value: 'monthly' },
      { label: 'Quarterly', value: 'quarterly' },
      { label: 'Half Yearly', value: 'halfyearly' },
      { label: 'Yearly', value: 'yearly' },
      { label: 'Night', value: 'night' },
      { label: 'Group', value: 'group' },
      { label: 'Family', value: 'family' },
      { label: 'Couple Monthly', value: 'couplemonthly' },
      { label: 'Couple Quarterly', value: 'couplequarterly' },
      { label: 'Couple Half Yearly', value: 'couplehalfyearly' },
      { label: 'Couple Yearly', value: 'coupleyearly' },
      { label: 'Student Monthly', value: 'studentmonthly' },
      { label: 'Student Quarterly', value: 'studentquarterly' },
      { label: 'Student Half Yearly', value: 'studenthalfyearly' },
      { label: 'Student Yearly', value: 'studentyearly' },
      { label: 'Youth', value: 'youth' },
      { label: 'Code', value: 'code' },
      { label: 'Optera', value: 'optera' },
      { label: 'Exergy', value: 'exergy' },
      { label: 'IBM', value: 'ibm' },
      { label: 'Elixir', value: 'elixir' },
      { label: 'Jazz', value: 'jazz' },
      { label: 'UBL HBL', value: 'ublhbl' },
      { label: 'Z Tech', value: 'ztech' },
      { label: 'Keep Truckin', value: 'keeptruckin' },
      { label: 'MCG', value: 'mcg' },
      { label: 'Shifa', value: 'shifa' },
      { label: 'ZTE', value: 'zte' },
      { label: 'ClaryIcon', value: 'claryicon' },
      { label: 'Site Effect', value: 'siteeffect' },
      { label: 'Zones', value: 'zones' },
      { label: 'TEO', value: 'teo' },
      { label: 'Radix Inova', value: 'radixinova' },
      { label: 'TEU', value: 'teu' },
      { label: 'Taekwondo', value: 'taekwondo' },
      { label: 'TecFolk', value: 'tecfolk' },

    ];
    this.packageFeeTypes = [
      { label: 'Select Fee Type', value: null },
      { label: 'Per Month Fee', value: 'per Month Fee' },
      { label: 'Whole Package Fee', value: 'whole package fee' },
    ]
    this.packageFeePersonWiseTypes = [
      { label: 'Select Fee Type', value: null },
      { label: 'Per Person Fee', value: 'per Person Fee' },
      { label: 'Whole Package Fee', value: 'whole package fee' },
    ]
    this.packageDurationTypes = [
      { label: 'Months', value: 'months' },
      { label: 'Weeks', value: 'weeks' },
      { label: 'Days', value: 'days' },
    ]
    this.packageRegFeePersonWiseTypes = [
      { label: 'Select Registration Fee Type', value: null },
      { label: 'Per Person Registration Fee', value: 'per Person Registration Fee' },
      { label: 'Whole Package Registration Fee', value: 'whole package Registration fee' },
    ]
    this.getPackagesn();
  }

  InitObjects() {
    this.package = new IPackageBuider();
    this.package.companyContactPerson = new ICompanyContactPackageBuider();
    this.package.registerationFee = 0;
    this.package.packageFee = 0;
    this.package.noOfMembers = 1;
    this.package.noOfMonths = 1;
    this.package.noOfWeeks = 0;
    this.package.noOfDays = 0;
    this.package.freezingDays = 0;
    this.package.isTimeBased = false;
    this.package.exceptions = [];
    this.groupFeePayByOnePerson = false;
    this.sameHistory = false;
    this.hasReadFeeCollectionDesc = false;
  }

  toggleGroupFeePayByOnePerson() {
    this.groupFeePayByOnePerson = !this.groupFeePayByOnePerson;
    if (!this.groupFeePayByOnePerson) {
      this.sameHistory = false;
      this.hasReadFeeCollectionDesc = false;
    } else {
      this.hasReadFeeCollectionDesc = false;
    }
  }

  toggleSameHistory() {
    if (!this.groupFeePayByOnePerson) {
      return;
    }
    this.sameHistory = !this.sameHistory;
  }

  showSameHistoryOption(): boolean {
    return this.groupFeePayByOnePerson && (this.package?.noOfMembers ?? 0) > 1;
  }

  private requireFeeCollectionDescAcknowledged(): boolean {
    if (!this.groupFeePayByOnePerson || this.hasReadFeeCollectionDesc) {
      return true;
    }
    this.messageService.clear();
    this.messageService.add({
      severity: 'warn',
      summary: 'Validation',
      detail: this.setLabel('feeCollectionDescRequiredErrorLabel') ||
        'Please confirm you have read the fee collection description.',
    });
    return false;
  }

  getPackagesn() {
    const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
    if (!branchId) {
      return;
    }
    this.appServiceManager.get(`branches/${branchId}/package-builders/actions/latest-sn`).subscribe((res: any) => {
      if (res.packagesSn) {
        this.package.sn = res.packagesSn;
        // this.loading = false;

      } else {
        this.package.sn = 1;
        // this.loading = false;
      }

    },
      (error) => {
        this.messageService.clear();
      });
  }

  steps() {
    this.items = [
      {
        label: 'Package Builder',
        command: (event: any) => {
          this.activeIndex = 0;
          // this.validateSignup();
        }
      },
      {
        label: 'Details',
        command: (event: any) => {
          this.activeIndex = 1;
          // this.validateSignup();
        }
      }
      // {
      //   label: 'Trainer Information',
      //   command: (event: any) => {
      //     this.activeIndex = 2;
      //     // this.validateSignup();
      //   }
      // },
      // {
      //   label: 'Identity Card',
      //   command: (event: any) => {
      //     this.activeIndex = 3;
      //   }
      // }
      // ,
      // {
      //   label: 'Fee Invoice',
      //   command: (event: any) => {
      //     this.activeIndex = 4;
      //   }
      // }
    ];
  }

  create(form: any) {
    if (
  this.package.ageGroupFrom != null &&
  this.package.ageGroupTo != null &&
  Number(this.package.ageGroupFrom) > Number(this.package.ageGroupTo)
) {
  return;
}
    if (form.valid) {
      if (!this.requireFeeCollectionDescAcknowledged()) {
        return;
      }
      this.zoneSaveTouched = true;
      if (this.hasZoneSelectionError()) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Validation', detail: 'Please select at least one zone before saving.' });
        return;
      }
      const timeBasedError = validateTimeBasedAccess({
        isTimeBased: this.isTimeBased,
        exceptionRows: this.exceptionRows,
        normalZones: this.zones,
      });
      if (timeBasedError) {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Validation', detail: timeBasedError });
        return;
      }
      this.openConfirmationDialog("Are you sure you want to save package?", () => {
          this.package.company = AuthService.getLoggedInCompany();
          this.package.branch = AuthService.getLoggedInBranch();
          this.package.logo = this.selectedLogo;
          this.package.createdBy = AuthService.getLoggedInUserId();
          this.package.createdDate = new Date();
          this.package.isDelete = false;
          if(this.isMonthWisePackage){
            this.package.packageFeeType = 'per Month Fee';
          }
          else{
            this.package.packageFeeType = 'per Person Fee';
          }
          this.package.packageRegFeeType = 'per Person Registration Fee';
          this.package.activityBy = this.user.name;
          this.package.type = 'New Package';
          this.package.scope = 'Package';
          this.package.initiatedFrom =  'AddPackage Builder';
          this.package.groupFeePayByOnePerson = this.groupFeePayByOnePerson;
          this.package.sameHistory = this.groupFeePayByOnePerson && (this.package.noOfMembers ?? 0) > 1
            ? this.sameHistory
            : false;
          this.package.durationType =  this.packageDurationType;
          this.package.freezingDays = this.package.freezingDays ? this.package.freezingDays : 0 ;
          this.package.zones = Array.isArray(this.zones) ? this.zones : [];
          applyTimeBasedFieldsToPackage(this.package, {
            isTimeBased: this.isTimeBased,
            exceptionRows: this.exceptionRows,
          });
          const branchId = AuthService.getLoggedInBranch() || this.user.branch;
          const createPayload = buildPackageBuilderCreatePayload(this.package, {
            company: this.package.company,
            branch: branchId,
          });
          this.package._id = String(createPayload._id);
          this.appServiceManager.post(
            `branches/${branchId}/package-builders`,
            createPayload,
          ).subscribe((res: any) => {
            const newId = res?._id || res?.id;
            // Zones are already on the create payload; keep legacy zones PUT when present.
            if (newId && Array.isArray(this.zones) && this.zones.length > 0 && !this.isTimeBased) {
              this.appServiceManager.put(
                `branches/${branchId}/package-builders/${newId}/actions/zones`,
                this.zones,
              ).subscribe(() => {
                this.messageService.clear();
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Package Successfully Created' });
                this.router.navigateByUrl('/package-Builders');
              }, (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
              });
            } else {
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Package Successfully Created' });
              this.router.navigateByUrl('/package-Builders');
            }
          }, (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      });
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }

  private openConfirmationDialog(message: string, action: () => void): void {
    this.confirmationDialogMessage = message;
    this.pendingConfirmationAction = action;
    this.confirmationDialogVisible = true;
  }

  cancelConfirmationDialog(): void {
    this.confirmationDialogVisible = false;
    this.pendingConfirmationAction = null;
  }

  confirmConfirmationDialog(): void {
    const action = this.pendingConfirmationAction;
    this.cancelConfirmationDialog();
    if (action) action();
  }

  getZonesByBranchID() {
    this.currentUser = localStorage.getItem('currentUser');
    const currentUserObj = JSON.parse(this.currentUser);
    this.branchId = currentUserObj?.branch;
    this.appServiceManager.get('branches/' + this.branchId + '/customers/act/actions/zones').subscribe((res: any) => {
      this.zones = res?.response || [];
      if (this.isTimeBased && this.exceptionRows.length === 0) {
        this.exceptionRows = [createEmptyExceptionRow(this.zones)];
      }
    }, (error) => {
      this.zones = [];
      this.exceptionRows = [];
    });
  }

  updateZoneSelection(event: boolean, index: number) {
    this.zones[index].IsSelect = event ? 1 : 0;
  }

  updateExceptionZoneSelection(rowIndex: number, zoneIndex: number, event: boolean) {
    this.exceptionRows[rowIndex].zones[zoneIndex].IsSelect = event ? 1 : 0;
  }

  toggleExceptionDay(rowIndex: number, day: number) {
    const row = this.exceptionRows[rowIndex];
    const idx = row.selectedDays.indexOf(day);
    if (idx >= 0) {
      row.selectedDays = row.selectedDays.filter((d) => d !== day);
    } else {
      row.selectedDays = [...row.selectedDays, day].sort((a, b) => a - b);
    }
  }

  isExceptionDaySelected(rowIndex: number, day: number): boolean {
    return this.exceptionRows[rowIndex].selectedDays.indexOf(day) >= 0;
  }

  onTimeBasedToggle(checked: boolean) {
    this.isTimeBased = checked;
    if (!checked) {
      this.exceptionRows = [];
    } else if (this.exceptionRows.length === 0) {
      this.exceptionRows = [createEmptyExceptionRow(this.zones)];
    }
  }

  addExceptionRow() {
    this.exceptionRows = [...this.exceptionRows, createEmptyExceptionRow(this.zones)];
  }

  getExceptionRowTitle(row: TimeBasedExceptionFormRow, index: number): string {
    return resolveExceptionRowTitle(row, index);
  }

  getAccessWindowLiveDescription(row: TimeBasedExceptionFormRow): string {
    return describeAccessWindowSelection(row, this.zones);
  }

  getCombinedAccessWindowsDescription(): string {
    return describeAllAccessWindows(this.exceptionRows, this.zones);
  }

  areScheduleZonesRequired(): boolean {
    return this.isTimeBased && !hasSelectedZones(this.zones);
  }

  removeExceptionRow(index: number) {
    if (this.exceptionRows.length <= 1) {
      return;
    }
    const title = this.getExceptionRowTitle(this.exceptionRows[index], index);
    this.confirmationService.confirm({
      message: `${this.setLabel('removeExceptionConfirmLabel')} (${title})`,
      accept: () => {
        this.exceptionRows = this.exceptionRows.filter((_, i) => i !== index);
      },
    });
  }

  hasExceptionZoneSelectionError(rowIndex?: number): boolean {
    if (!this.isTimeBased) {
      return false;
    }
    // When normal ACT zones are selected, window zones are optional.
    if (hasSelectedZones(this.zones)) {
      return false;
    }
    if (typeof rowIndex === 'number') {
      const row = this.exceptionRows[rowIndex];
      if (!row || !Array.isArray(row.zones) || row.zones.length === 0) {
        return false;
      }
      return row.zones.every((zone) => zone?.IsSelect !== 1);
    }
    return this.exceptionRows.some((_, i) => this.hasExceptionZoneSelectionError(i));
  }

  hasZoneSelectionError(): boolean {
    // Time-based packages use access-window zones; top ACT zones are optional.
    if (this.isTimeBased) {
      return false;
    }
    if (!Array.isArray(this.zones) || this.zones.length === 0) {
      return false;
    }
    return this.zones.every(zone => zone?.IsSelect !== 1);
  }

getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
   if(!this.branch){
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          this.branch = res;
          localStorage.setItem('currentBranch', JSON.stringify(res));
        } else {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add(
            { severity: 'info', 
              summary: 'Info Message', 
              detail: 'Something Went Wrong' }
            );
        }
      },
        (error) => {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add(
            { severity: 'error', 
              summary: 'Error Message', 
              detail: error }
            );
        });
   }
  }

  selectSubcription(packageType) {
    this.package.packageType = packageType;
    switch (this.package.packageType) {
      case 'Month Wise Package':
        this.isMonthWisePackage = true; // input is disabled
        break;
      case 'Person Wise Package':
        this.isPersonWisePackage = true; // input is disabled
        break;
      case 'Duplicate Package':
        this.activeIndex = 3;
        this.loading = true;
        this.getPackageBuilders();
        break;
      case 'Company Package':
        this.isPersonWisePackage = true; // input is disabled
        break;

      default:
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "No Package is Selected Please go back and select the package" });
        break;
    }
    if (this.package.packageType == 'Month Wise Package') {

    }
    // else if (this.package.packageType == 'Month Wise Package') {
    //   this.isCompanyWisePackage = true; // input is disabled
    // }
    this.validateSignup();
  }
  getPackageBuilders() {
    this.packages = [];
    this.sourcePackages = [];
    this.loading = true;
    this.appServiceManager.get('branches/' + this.user.branch + '/package-builders').subscribe((res: IPackageBuider[]) => {
      if (res.length > 0) {
        this.packages = res.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
        this.sourcePackages = res.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
        this.loading = false;
      } else {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "No Record Found" });
      }

    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  duplicatePackage(packageBuilder: IPackageBuider){
    if (this.activeIndex === 3) {
      this.package.sn = this.packages.length + 1 ;
      this.package.packageName = packageBuilder.packageName + " DUPLICATE" ;
      this.package.packageType = packageBuilder.packageType;
      this.package.color = packageBuilder.color;
      this.package.description = packageBuilder.description;
      this.package.noOfMembers = packageBuilder.noOfMembers;
      this.package.packageFee = packageBuilder.packageFee;
      this.package.registerationFee = packageBuilder.registerationFee;
      this.package.noOfMonths = packageBuilder.noOfMonths;
      this.package.noOfWeeks = packageBuilder.noOfWeeks;
      this.package.noOfDays = packageBuilder.noOfDays;
      this.package.ageGroupFrom = packageBuilder.ageGroupFrom;
      this.package.ageGroupTo = packageBuilder.ageGroupTo;
      this.package.freezingDays = packageBuilder.freezingDays;
      this.packageDurationType = packageBuilder.durationType;
      this.activeIndex = 1;
    }
  }
  validateSignup() {
    if (this.activeIndex === 0) {
      this.activeIndex = 1;
    }
  }

  reverse() {
    if (this.activeIndex === 1) {
      this.activeIndex = 0;
    } else if (this.activeIndex === 2) {
      this.activeIndex = 1;
    }
  }


}
